import { Base } from "../../framework/base";
import { ListItems } from "../../framework/listItems";
import { CalendarTaskItem, ICalendarTaskItem } from "./calendarTaskItem";

export interface ICalendarTaskItems extends ListItems<ICalendarTaskItem> {
    startDate: number;
    endDate: number;
    prevItem: ICalendarTaskItem;
    nextItem: ICalendarTaskItem;
}

export class CalendarTaskItems extends ListItems<CalendarTaskItem> implements ICalendarTaskItems {
    startDate: number;
    endDate: number;
    prevItem: CalendarTaskItem;
    nextItem: CalendarTaskItem;

    constructor();
    constructor(obj: ICalendarTaskItems);
    constructor(obj?: any) {
        super(obj);
        this.startDate = obj && obj.startDate || 0;
        this.endDate = obj && obj.endDate || 0;
        this.items = Base.getTypedArray(obj ? obj.items : null, CalendarTaskItem);
        this.prevItem = obj && obj.prevItem ? new CalendarTaskItem(obj.prevItem) : null;
        this.nextItem = obj && obj.nextItem ? new CalendarTaskItem(obj.nextItem) : null;
    }
}